import React, { useContext, useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { AxiosContext } from "../../../app/assets/axios/admin/AxiosComponent";
// import UserInput from "../../FormAddInputComponent/create-user-input";
import { useForm } from "react-hook-form";
import { postCreateForm, fetchUserGroupList } from "../../../actions/admin/actionCreators";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import CollapsedBreadcrumbs, { BreadcrumbsContext } from "../../../layouts/admin/breadcrumb";
import { Card, CardHeader, CardContent, CardActions, Button, Grid } from "@mui/material";
import TextFieldComponent from "../../FormAddInputComponent/TextField";
import SelectOptionComponent from "../../FormAddInputComponent/SelectOption";
import { AppBarSpacer, CardHeaderCss } from "../../../css/Admin-css/listing-css";

export default function UserCreate() {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const {
        watch,
        handleSubmit,
        control,
        formState: { errors },
        setValue,
    } = useForm({
        mode: "all",
    });

    const api = useContext(AxiosContext);
    const navigate = useNavigate();

    const onSubmit = handleSubmit(async (data) => {
        document.getElementById("splash-screen").classList.remove("hidden");
        const response = await postCreateForm({
            api: api,
            data: data,
            method: "POST",
            url: "CreateNewAdmin",
            enqueueSnackbar,
        });

        if (response) {
            document.getElementById("splash-screen").classList.add("hidden");
            if (response.data.status === 200) {
                enqueueSnackbar(response.data.msg_title, {
                    variant: "success",
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "center",
                    },
                });
                navigate("/admin/user-list");
            }
        }
    });

    const statusList = [
        { id: "A", name: "Active" },
        { id: "I", name: "Inactive" },
    ];
    const [breadcrumbArr, setBreadcrumbArr] = React.useState([
		{
			text: "Admin",
			link: "/admin/user-list",
		}, 
		{
			text: "Admin Form",
			link: "/admin/user/create",
		}, 
	]);

    const password = useRef({});
    password.current = watch("password");
    const [status, setStatus] = useState("");
    const [userGroup, setUserGroup] = useState("");
    const [userGroupData, setUserGroupData] = useState([]);

    const onSelectChangeHandler = (name) => (event) => {
        const value = event.target.value;
        if (name == "status") {
            setStatus(value);
        } else if (name == "user_group_id") {
            setUserGroup(value);
        }
        setValue(name, value);
    };

    const getUserGroupList = async () => {
        const response = await fetchUserGroupList({
              api: api,
              url: "getUserGroupList",
              enqueueSnackbar,
              dispatch,
        });

        if (response) {
            if (response.data.data) {
                setUserGroupData(response.data.data);
            }
        }
    };

    useEffect(() => {
        getUserGroupList();
    }, []);

    return (
        <>
            <BreadcrumbsContext.Provider value={[breadcrumbArr, setBreadcrumbArr]} >
				<CollapsedBreadcrumbs />
			</BreadcrumbsContext.Provider>
            {/* <UserInput
                classes={classes}
                errors={errors}
                statusList={statusList}
                control={control}
                onSubmit={onSubmit}
                watch={watch}
                setValue={setValue}
            /> */}

            <Card>
                <CardHeaderCss title="Create User"/>
                <CardContent>
                    <form>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} style={{paddingTop: 0}}>
                                <TextFieldComponent
                                    control={control}
                                    name="name"
                                    marginType="normal"
                                    label="Full Name"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "this field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{paddingTop: 0}}>
                                <TextFieldComponent
                                    control={control}
                                    name="nick_name"
                                    marginType="normal"
                                    label="Username"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "this field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{paddingTop: 0}}>
                                <TextFieldComponent
                                    control={control}
                                    name="email"
                                    marginType="normal"
                                    label="Email Address"
                                    helperText="We'll never share your email with anyone else"
                                    style={{ margin: 8 }}
                                    type="email"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "this field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{paddingTop: 0}}>
                                <SelectOptionComponent
                                    control={control}
                                    name="status"
                                    placeholder="Status"
                                    label="Status"
                                    option={statusList}
                                    onChangeHandler={onSelectChangeHandler("status")}
                                    value={status}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "this field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{paddingTop: 0}}>
                                <TextFieldComponent
                                    control={control}
                                    name="password"
                                    placeholder="Password"
                                    marginType="normal"
                                    label="Password"
                                    type="password"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "this field is required",
                                        },
                                        minLength: {
                                            value: 8,
                                            message: "Password must have at least 8 characters",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{paddingTop: 0}}>
                                <TextFieldComponent
                                    control={control}
                                    name="confirm_password"
                                    placeholder="Confirm Password"
                                    marginType="normal"
                                    label="Confirm Password"
                                    type="password"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "this field is required",
                                        },
                                        minLength: {
                                            value: 8,
                                            message: "Password must have at least 8 characters",
                                        },
                                        validate: (value) =>
                                        value === password.current ||
                                        "The passwords do not match",
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <SelectOptionComponent
                                    control={control}
                                    name="user_group"
                                    placeholder="User Group"
                                    label="User Group"
                                    option={userGroupData}
                                    onChangeHandler={onSelectChangeHandler("user_group_id")}
                                    value={userGroup}
                                    errors={errors}
                                />
                            </Grid>
                        </Grid>
                        <AppBarSpacer />
                        <div align="center">
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                onClick={onSubmit}
                                size="large"
                            >
                                Submit
                            </Button>
                        </div>
                    </form>
                </CardContent>
            </Card>
        </>
    );
}
